import { Line, LineDirectory, LineOrDirectoryPatch, LineWithEagerlyLoadedStations } from '@paragon/contract-library';

import { DesignService } from '../connections';

interface LineCreationRequest {
  readonly name: string;
  readonly parentGuid?: string | null;
}

export function createLine(data: LineCreationRequest): Promise<LineDirectory> {
  return DesignService.post(`production/lines`, { data });
}

export function get(): Promise<{ lines: Line[] }> {
  return DesignService.get('production/lines');
}

export function getEagerlyLoadedLinesAndDirectoriesForCurrentOrganization(): Promise<{
  lines: LineWithEagerlyLoadedStations[];
  directories: LineDirectory[];
}> {
  // CAUTION: The return type depends on what values are passed in `include`
  return DesignService.get('production/lines?include=directories,stations');
}

export function patchLine(lineGuid: string, data: LineOrDirectoryPatch): Promise<Line> {
  return DesignService.patch(`production/lines/${lineGuid}`, { data });
}

export function deleteLine(lineGuid: string): Promise<void> {
  return DesignService.delete(`production/lines/${lineGuid}`);
}

export function addStationToLine(lineGuid: string, stationGuid: string): Promise<void> {
  return DesignService.put(`production/lines/${lineGuid}/stations/${stationGuid}`);
}

export function removeStationFromLine(lineGuid: string, stationGuid: string): Promise<void> {
  return DesignService.delete(`production/lines/${lineGuid}/stations/${stationGuid}`);
}
